import React from "react";
import moment from "moment";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  LabelList
} from "recharts";

// import {fakeTrendData} from './fakeData'

const CommonTimeLineChart = ({ data, type }) => {
  // data=fakeTrendData;
  const fillNull = (dataArray) => {
    const keys = ['g_down', 'g_up', 'g_rsrp'];
    dataArray.forEach(obj => {
      keys.forEach(key => {
        if (!(key in obj)) {
          obj[key] = null;
        }
      });
    });
  };
  fillNull(data)




  const uniqueDates = [...new Set(data.map((item) => new Date(item.date)))];
  // Find minimum and maximum dates
  // const minDate = new Date(Math.min(...uniqueDates));
  // const maxDate = new Date(Math.max(...uniqueDates));

  // const resultAxises = [];
  // let currentDate = new Date(minDate);

  let formatterFunc = (unixTime) => {
    const day = moment.unix(unixTime).format("DD/MM/YY");
    return day;
  };

  if (type === "Weekly") {
    // while (currentDate <= maxDate) {
    //   resultAxises.push(new Date(currentDate).toISOString().slice(0, 10));
    //   currentDate.setDate(currentDate.getDate() + 7);
    // }
    formatterFunc = (unixTime) => {
      const week = moment.unix(unixTime).format("MMM YYYY");
      return week;
    };
  } else if (type === "Daily") {
    // while (currentDate <= maxDate) {
    //   resultAxises.push(new Date(currentDate).toISOString().slice(0, 10));
    //   currentDate.setDate(currentDate.getDate() + 1);
    // }
    formatterFunc = (unixTime) => {
      const day = moment.unix(unixTime).format("DD/MM/YY");
      return day;
    };
  } else if (type === "Monthly") {
    // while (currentDate <= maxDate) {
    //   resultAxises.push(new Date(currentDate));
    //   currentDate.setMonth(currentDate.getMonth() + 1);
    // }
    formatterFunc = (unixTime) => {
      const month = moment.unix(unixTime).format("MMM YY");
      return month;
    };
  }



  let minValue = Math.min(...data.map(item => Math.min(item.g_down, item.g_up, item.g_rsrp)));
  let maxValue = Math.max(...data.map(item => Math.max(item.g_down, item.g_up, item.g_rsrp)));

  minValue = Math.max(Math.floor((minValue - 5) / 5) * 5, 0);
  maxValue = Math.min(Math.ceil((maxValue + 5) / 5) * 5, 100);

  const integerFormatter = value => `${Math.round(value)}`; // Formatting


  // // Create a map from the original data array for efficient lookup
  // const dataMap = new Map(data.map((obj) => [obj.date, obj]));

  // // Fill in missing dates
  // const filledData = allDates.map((date) => {
  //   if (dataMap.has(date)) {
  //     return dataMap.get(date);
  //   } else {
  //     return { date: date, g_down: null, g_up: null, g_rsrp: null };
  //   }
  // });


  const generateXAxisTicks = (dates) => {
    const uniqueMonths = new Map();
    const result = [];

    for (const date of dates) {
      const yearMonth = `${new Date(date).getUTCFullYear()}-${new Date(date).getUTCMonth()}`;
      if (!uniqueMonths.has(yearMonth)) {
        uniqueMonths.set(yearMonth, true);
        result.push(date);
      }
    }

    // Ensure the last date is always included
    if (result[result.length - 1] !== dates[dates.length - 1]) {
      result.push(dates[dates.length - 1]);
    }

    return result;
  };



  const ticks = generateXAxisTicks(uniqueDates);
  // ticks.push(data[totalEntries-1].date)
  // console.log(ticks)

  const getFirstItemFromEachUniqueMonth = (dates) => {
    const uniqueMonths = new Map();
    const result = [];

    for (const date of dates) {
      const yearMonth = `${new Date(date).getUTCFullYear()}-${new Date(date).getUTCMonth()}`;
      if (!uniqueMonths.has(yearMonth)) {
        uniqueMonths.set(yearMonth, true);
        result.push(date);
      }
    }
    return result;
  };


  const xTicks = type === "Daily" ? ticks : getFirstItemFromEachUniqueMonth(ticks);
  const unixTimes = xTicks.map((item) => moment(item).unix());
  const minUnixTime = Math.min(...unixTimes);
  const maxUnixTime = Math.max(...unixTimes);

  const unixData = data.map((item) => ({
    ...item,
    unix_time: moment(item.date).unix(),
  }));

  // ticks.pop() .unix(unixTime)

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const units = {
        g_rsrp: "dBm",
        g_down: "Mbps",
        g_up: "Mbps",
      };
      const decimals = {
        g_rsrp: 0,
        g_down: 2,
        g_up: 2,
      };
      const getDisplayNameAndColor = (name) => {
        switch (name) {
          case "g_rsrp":
            return { displayName: "Signal Strength", color: "#FFBF00", borderColor: "#d49f02"  };
          case "g_down":
            return { displayName: "Download", color: "#39FF14", borderColor: "#2ecf11" };
          case "g_up":
            return { displayName: "Upload", color: "#15F4EE", borderColor: "#12c9c5" };
          default:
            return { displayName: name, color: "#000000", borderColor: "#000000" };
        }


      };

      const getValueFromEntry = (entry) => {
        const mapping = {
          g_down: 'a_down',
          g_up: 'a_up',
          g_rsrp: 'a_dbm'
        };

        const key = mapping[entry.name];
        return entry.payload[key];
      };





      return (
        <div style={{ lineHeight: "0.7", fontWeight: "normal", fontFamily: "'Open Sans', sans-serif", fontSize: "12px", backgroundColor: "#fff", padding: "5px", border: "1px solid #ccc", boxShadow: '0 0 5px rgba(0, 0, 0, 0.2)', borderRadius: '5px' }}>
          <p style={{ lineHeight: "0.7", fontSize: "12px", marginTop: "0", fontWeight: 'bold', color: '#000000' }}>Date: {moment.unix(label).format("DD/MM/YYYY")}</p>
          {payload.map((entry, index) => {
            const detail = getDisplayNameAndColor(entry.name);
            if (!detail) return null; // Skip rendering this entry if it's not one of the handled cases

            const { displayName, color, borderColor } = detail;
            const value = getValueFromEntry(entry);

            return (
              <div key={`item-${index}`} style={{ display: 'flex', alignItems: 'center', color: '#000000', marginBottom: '4px' }}>
                <span style={{ height: '10px', width: '10px', backgroundColor: color, borderRadius: '50%', display: 'inline-block', border: `2px solid ${borderColor}`, marginRight: "4px" }}></span>
                <span style={{ marginRight: '3px', minWidth: '100px', display: 'inline-block', textAlign: 'left' }}>{displayName}:</span>
                <span>{typeof value === 'number' ? value.toFixed(decimals[entry.name]) : value} {units[entry.name]}</span>
              </div>
            );
          })}
        </div>
      );
    }
    return null;
  };

  // console.log(unixData)
  const totalEntries = data.length;
  const totalGDown = data.reduce((acc, curr) => curr.g_down !== undefined ? acc + curr.g_down : acc, 0);
  const totalGUp = data.reduce((acc, curr) => curr.g_up !== undefined ? acc + curr.g_up : acc, 0);
  const totalGRsrp = data.reduce((acc, curr) => curr.g_rsrp !== undefined ? acc + curr.g_rsrp : acc, 0);
  const avgGDown = totalGDown / totalEntries;
  const avgGUp = totalGUp / totalEntries;
  const avgGRsrp = totalGRsrp / totalEntries;

  
  return (
    <ResponsiveContainer
      width="100%"
      height="100%"
      style={{ marginLeft: "-28px" }}
    >
      <LineChart width={600} height={350} data={unixData}>
        <CartesianGrid strokeDasharray="4 5" stroke="rgba(0, 0, 0, 0.1)" />
        <XAxis
          dataKey="unix_time"
          type="number"
          tickFormatter={formatterFunc}
          ticks={unixTimes}
          domain={[minUnixTime, maxUnixTime]}
          fontSize={10}
          fontWeight={"bold"}
          angle={type === "Daily" ? 35 : 0}
          tick={{ dy: 4, dx: -5 }}
        />
        <YAxis fontSize={10} fontWeight={"bold"} domain={[minValue, maxValue]} tickFormatter={integerFormatter} />
        <Line dataKey="g_rsrp" connectNulls stroke="#FFBF00" strokeWidth={1} dot={false} >
        <LabelList dataKey="g_rsrp" position="top" fontSize={9} formatter={(val)=>{return val.toFixed(0)}}/>
        </Line>
        <Line dataKey="g_down" connectNulls stroke="#39FF14" strokeWidth={1} dot={false} >
        <LabelList dataKey="g_down" position="top" fontSize={9} formatter={(val)=>{return val.toFixed(0)}}/>
        </Line>
        <Line dataKey="g_up" connectNulls stroke="#15F4EE" strokeWidth={1} dot={false} >
        <LabelList dataKey="g_up" position="top" fontSize={9} formatter={(val)=>{return val.toFixed(0)}}/>
        </Line>

        {/* Reference lines for average values */}
        <ReferenceLine y={avgGRsrp} stroke="#FFBF00" strokeDasharray="3 3" />
        <ReferenceLine y={avgGDown} stroke="#39FF14" strokeDasharray="3 3" />
        <ReferenceLine y={avgGUp} stroke="#15F4EE" strokeDasharray="3 3" />

        <Tooltip content={<CustomTooltip />} />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default CommonTimeLineChart;
